<template>
  <div class="dingdan">
<!--    <breadcrumb :routerList="[{to:'/dingd/dingdwxlist',title:'订单管理'},{title:'订单列表(外销)'}]" v-if="firstPageFlag!=1"/>-->
    <Breadtabsheader/>
    <div class="h-piece h-mrt30 margin">
      <div class="h-formBox">
        <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder" ref="form">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="订单编号" prop="sapCode" style="width: 50%;">
              <el-input v-model="formInline.sapCode" placeholder="多订单模糊查询请用空格或分号分隔"></el-input>
            </el-form-item>
            <el-form-item label="　创建人编码/名称" prop="cuserCodeNameLike">
              <el-input v-model="formInline.cuserCodeNameLike" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="订单类型" prop="orderCategory1">
              <el-select v-model="formInline.orderCategory1" clearable placeholder="请选择" style="width:100%">
                <el-option v-for="item in orderCategory1List"
                           :key="item.code"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-collapse-transition>
            <div v-show="isScreen">
              <div class="h-thirdColumn w-newColumn">
                <el-form-item label="　　订单创建时间" prop="cdatebegin" style="width: 50%;">
                  <el-date-picker
                      v-model="formInline.cdatebegin"
                      clearable
                      type="date"
                      value-format="yyyy-MM-dd" >
                  </el-date-picker>
                  <span class="w-time-to">至</span>
                  <el-date-picker
                      v-model="formInline.cdateend"
                      clearable
                      type="date"
                      value-format="yyyy-MM-dd" >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="　售达方编码/名称" prop="sdfCodeNameLike">
                  <el-input v-model="formInline.sdfCodeNameLike" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="订单状态" prop="status">
                  <brselect clearable category="order_status" :v="formInline.status"
                            v-model="formInline.status"></brselect>
                </el-form-item>
              </div>
              <div class="h-thirdColumn w-newColumn">
                <el-form-item label="　　是否手动收货" v-auth="'caiwushouhuo'" prop="shouhuoflag">
                  <brselect clearable category="shifou_keyong" :v="formInline.shouhuoflag" v-model="formInline.shouhuoflag"></brselect>
                </el-form-item>
                <el-form-item label="所属大区" prop="dqcode">
                  <el-select v-model="formInline.dqcode" clearable placeholder="请选择" style="width:100%" @change="changeDqCate">
                    <el-option v-for="item in dqcodeList"
                               :key="item.dqcode"
                               :label="item.dqname"
                               :value="item.dqcode">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="国家" prop="shipToAreaCode">
                  <el-select v-model="formInline.shipToAreaCode" clearable placeholder="请选择" style="width:100%">
                    <el-option v-for="item in shipToAreaCodeList"
                               :key="item.gjcode"
                               :label="item.gjname"
                               :value="item.gjcode">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="　产品编码/名称" prop="materialCodeNameLike">
                  <el-input v-model="formInline.materialCodeNameLike" placeholder="请输入"></el-input>
                </el-form-item>

              </div>
              <div class="h-thirdColumn w-newColumn">
                <el-form-item label="发货时间" prop="fhdatebegin" style="width: 50%;">
                  <el-date-picker
                      v-model="formInline.fhdatebegin"
                      clearable
                      type="date"
                      value-format="yyyy-MM-dd" >
                  </el-date-picker>
                  <span class="w-time-to">至</span>
                  <el-date-picker
                      v-model="formInline.fhdateend"
                      clearable
                      type="date"
                      value-format="yyyy-MM-dd" >
                  </el-date-picker>
                </el-form-item>

                <el-form-item label="产地" prop="factory">
                  <brselect category="factory" :v="formInline.chandidata" :showcode="true"
                            v-model="formInline.chandidata" :multiple="true" :collapse-tags="true" clearable></brselect>
                </el-form-item>
                <el-form-item label="销售组织" prop="saleGroupCode">
                  <brselect category="xiaoshou_zuzhi" :v="formInline.saleGroupCode" :showcode="true"
                            v-model="formInline.saleGroupCode" clearable></brselect>
                </el-form-item>
              </div>
              <div class="h-thirdColumn w-newColumn">

                <el-form-item prop="fujianStatusFlag" class="clstyle">
                  <el-switch
                      v-model="formInline.fujianStatusFlag"
                      active-text="已开票订单"
                      inactive-text="查看所有"
                      @change="fujianStatusFlag()">
                  </el-switch>
                </el-form-item>

              </div>

            </div>
          </el-collapse-transition>

                    <!-- <div class="h-formBtnOut h-columnCenter">
                        <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
                        </el-button>
                        <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" style="width:1.6rem;"
                                   @click="imgfalse3" v-if="firstPageFlag!=1">
                            新建订单
                        </el-button>
                        <el-button v-auth="'caiwushouhuo'" class="h-btn h-formBtn h-bggreen"
                                   @click="caiwushouhuo">
                            收货
                        </el-button>
                    </div> -->
                </el-form>
				<div class="l-screenBox">
					<div class="l-screen" @click="collapseChange">
						<img :src="isScreen?closeScreen:drawScreen" alt="">
						<div class="l-screenText">{{isScreen?"收起":"下拉"}}</div>
					</div>
					<div class="l-retrieval">
						<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
						<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
						</el-button>
						<el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
						           @click="imgfalse3" v-if="firstPageFlag!=1">
						    新建订单
						</el-button>
						<el-button v-auth="'caiwushouhuo'" class="h-btn h-formBtn h-bggreen"
						           @click="caiwushouhuo">
						    收货
						</el-button>
					</div>
				</div>
            </div>
        </div>
		<div class="h-mrt30 margin">
			<h6 style="color: red;font-size: 0.14rem;margin-top: 0.1rem;">每月的最后一天中午12点至次日凌晨4点为系统禁止签收时间，不可进行签收操作！</h6>
<!--            <h6 style="color: red;font-size: 0.14rem;margin-top: 0.1rem;">2022年4月签收截止日期为4月29日中午12点,请及时签收！</h6>-->
        </div>
        <div class="h-table h-mrt30">
            <el-table
                    ref="ddtable"
                    :data="tableData"
                    :span-method="objectSpanMethod"
                    @selection-change="handleSelectionChange"
                    stripe
            		border
                    :show-overflow-tooltip="true"
                    style="width: 100%"
            		max-height="510"
            >
                <el-table-column
                        type="selection"
                        fixed
                        width="40">
                </el-table-column>
                <el-table-column
                        type="index"
            			fixed
                        label="#"
                        width="40">
                </el-table-column>
                <el-table-column
                        prop="sapCode"
                        label="订单号"
            			fixed
            			:show-overflow-tooltip="true"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="materialCode"
                        label="产品编码"
            			:show-overflow-tooltip="true"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="materialName"
                        label="产品名称"
                        :show-overflow-tooltip="true"
                        width="180">
            			<template scope="scope">
            				<div style="text-align: left;">
            					{{scope.row.materialName}}
            				</div>
            			</template>
                </el-table-column>
              <el-table-column
                  prop="oemDesc"
                  label="规格型号"
                  width="140"
                  :show-overflow-tooltip="true"
              >
              </el-table-column>
                <el-table-column
                        prop="factory"
                        label="产地"
                        width="140"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        prop="status"
                        label="订单状态"
            			:show-overflow-tooltip="true"
                        width="80">
                    <template scope="scope">
            			<div style="text-align: left;">{{scope.row.status|dictname('order_status')}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="orderCategory1"
                        label="订单类型"
                        :show-overflow-tooltip="true"
                        width="120">
                    <template scope="scope">
                        {{scope.row.orderCategory1|dictname('xiaoshou_quyu_nwx') }}
                    </template>
                </el-table-column>
                <!--
                <el-table-column
                        prop="saleGroupCode"
                        label="销售组织"
                        :show-overflow-tooltip="true"
                        width="330">
            		<template scope="scope">
            			<div style="text-align: left;">
            				[{{scope.row.saleGroupCode}}]{{scope.row.saleGroupCode|dictname('YLSalesOrganization_agent')}}
            			</div>
            		</template>
                </el-table-column>
                -->
                <el-table-column
                        prop="soldToCode"
                        label="售达方编码"
            			:show-overflow-tooltip="true"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="soldToName"
                        label="售达方名称"
                        :show-overflow-tooltip="true"
                        min-width="180">
            			<template scope="scope">
            			    <div style="text-align: left;">
            					{{scope.row.soldToName}}
            				</div>
            			</template>
                </el-table-column>
                <el-table-column
                        prop="soldToAreaName"
                        label="售达方地区"
                        :show-overflow-tooltip="true"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="shipToAreaName"
                        label="送达方地区"
                        :show-overflow-tooltip="true"
                        width="100">
                </el-table-column>

				<el-table-column
						prop="proNumber"
						label="数量"
						:show-overflow-tooltip="true"
						width="60">
					<template scope="scope">
						<div style="text-align: right;">
							{{scope.row.proNumber}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
						prop="finalPrice"
						label="成交价"
						:show-overflow-tooltip="true"
						width="80">
					<template scope="scope">
						<div style="text-align: right;">
							{{scope.row.finalPrice}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
						prop="totalprice"
						label="总价"
						width="80">
					<template scope="scope">
						<div style="text-align: right;">
							{{scope.row.totalprice}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
						prop="extraPrice"
						label="改制加价"
						width="90">
					<template scope="scope">
						<div style="text-align: right;">
							{{scope.row.extraPrice}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
						prop="extraDes"
						label="改制描述"
						width="90">
					<template scope="scope">
						<div style="text-align: right;">
							{{scope.row.extraDes}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
						prop="feeyongj"
						label="佣金"
						width="60">
					<template scope="scope">
						<div style="text-align: right;">
							{{scope.row.feeyongj}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
						prop="feebaof"
						label="保费"
						width="60">
					<template scope="scope">
						<div style="text-align: right;">
							{{scope.row.feebaof}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
						prop="feeyunf"
						label="运费"
						width="60">
					<template scope="scope">
						<div style="text-align: right;">
							{{scope.row.feeyunf}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
						prop="hjmaozh"
						label="毛重"
						width="60">
					<template scope="scope">
						<div style="text-align: right;">
							{{scope.row.hjmaozh}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
						prop="hjjinzh"
						label="净重"
						width="60">
					<template scope="scope">
						<div style="text-align: right;">
							{{scope.row.hjjinzh}}
						</div>
					</template>
				</el-table-column>
                <el-table-column
                        prop="measure"
                        label="尺寸(长宽高)"
                        width="100">
                    <template scope="scope">
                        <div style="text-align: right;">
                            {{scope.row.measure}}
                        </div>
                    </template>
                </el-table-column>

        <el-table-column
            prop="currencyCode"
            label="币种编码"
            :show-overflow-tooltip="true"
            width="80">
        </el-table-column>
        <el-table-column
            prop="orderPrice"
            :show-overflow-tooltip="true"
            label="订单总价"
            width="80">
          <template scope="scope">
            <div style="text-align: right;">
              {{scope.row.orderPrice}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            prop="orderPriceRbm"
            label="RMB总价"
            :show-overflow-tooltip="true"
            width="90">
          <template scope="scope">
            <div style="text-align: right;">
              {{scope.row.orderPriceRbm}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            prop="orderNetWorth"
            label="不含税总价"
            :show-overflow-tooltip="true"
            width="100">
          <template scope="scope">
            <div style="text-align: right;">
              {{scope.row.orderNetWorth}}
            </div>
          </template>
        </el-table-column>
        <!--
        <el-table-column
                prop="disChannelCode"
                label="分销渠道编码"
                :show-overflow-tooltip="true"
                width="140">
            <template scope="scope">
                {{scope.row.disChannelCode|dictname('fenxiao_qudao')}}
            </template>
        </el-table-column>
        -->
        <el-table-column
            prop="cuname"
            label="创建人名称"
            :show-overflow-tooltip="true"
            width="140">
          <template scope="scope">
            <div style="text-align: left;">
              {{scope.row.cuname}}[{{scope.row.cucode}}]
            </div>
          </template>
        </el-table-column>
        <el-table-column
            prop="cdate"
            label="创建时间"
            width="90"
            :formatter="formatDate"
        >
        </el-table-column>


        <el-table-column
            prop="wldw"
            label="单位"
            :show-overflow-tooltip="true"
            width="60">
        </el-table-column>


        <el-table-column
            prop="finalPrice"
            label="成交价"
            :show-overflow-tooltip="true"
            width="80">
          <template scope="scope">
            <div style="text-align: right;">
              {{scope.row.finalPrice}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            prop="totalprice"
            label="总价"
            width="100">
          <template scope="scope">
            <div style="text-align: right;">
              {{scope.row.totalprice}}
            </div>
          </template>
        </el-table-column>

        <el-table-column
            prop="totalprice"
            label="汇算总价"
            width="100">
          <template scope="scope">
            <div style="text-align: right;">
              {{scope.row.totalprice}}
            </div>
          </template>
        </el-table-column>

        <el-table-column
            prop="acceptTime"
            label="签收时间"
            :show-overflow-tooltip="true"
            width="100">
        </el-table-column>
        <el-table-column
            prop="thawStatus"
            label="签收状态"
            :show-overflow-tooltip="true"
            width="60">
          <template scope="scope">
            <span v-if="scope.row.thawStatus == 'N'">未签收</span>
            <span v-if="scope.row.thawStatus == 'Y'">已签收</span>
          </template>
        </el-table-column>
        <el-table-column
            fixed="right"
            label="操作"
            width="250"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.orderCategory1 == '26'" style="text-align: left;">
              <div v-if="scope.row.status == '10'" style="text-align: left;">
                <el-button
                    size="small" class="h-tableLink h-btn"
                    @click="handleEdit(scope.row)">编辑
                </el-button>
<!--                <el-button-->
<!--                    size="small" class="h-tableLink h-btn"-->
<!--                    @click="sapDeleteOrder2(scope.row)">删除-->
<!--                </el-button>-->
              </div>
                <el-button v-if="scope.row.binstid"
                           size="small" class="h-tableLink h-btn"
                           @click="genzongLiuch(scope.row)">
                  跟踪
                </el-button>
                <el-button
                    size="small" class="h-tableLink h-btn"
                    @click="handelDetail(scope.row)">查看
                </el-button>
                <el-button
                    v-if="scope.row.status == 30"
                    size="small" class="h-tableLink h-btn"
                    @click="sapDeleteOrder2(scope.row)">删除
                </el-button>

                <el-button
                    v-if="_user.usercode == scope.row.cucode && scope.row.status == 20"
                    size="small" class="h-tableLink h-btn"
                    @click="sapCHOrder(scope.row)">撤回
                </el-button>

<!--              <el-button-->
<!--                    v-if=" scope.row.orderCategory1 == '41' && scope.row.thawStatus == 'N'"-->
<!--                    size="small" class="h-tableLink h-btn"-->
<!--                    @click="importAllruhuo(scope.row)">签收-->
<!--              </el-button>-->
                <el-button
                    v-if="scope.row.orderCategory1 == '41'"
                    size="small" class="h-tableLink h-btn"
                    @click="seeFile(scope.row)">查看附件
                </el-button>
            </div>
            <div v-else style="text-align: left;">
              <div v-if="scope.row.status == '10'">
                <el-button
                    size="small" class="h-tableLink h-btn"
                    @click="handleEdit(scope.row)">编辑
                </el-button>
                <el-button
                    size="small" class="h-tableLink h-btn"
                    @click="sapDeleteOrder2(scope.row)">删除
                </el-button>
              </div>
              <div v-else style="text-align: left;">
<!--								<span v-if="_user.usercode == scope.row.cucode">-->
<!--									<el-button-->
<!--                      v-if="scope.row.shenpiflag"-->
<!--                      size="small" class="h-tableLink h-btn"-->
<!--                      @click="shenpiopt(scope.row, '1')">-->
<!--									提报-->
<!--									</el-button>-->
<!--								</span>-->
<!--                <span v-else>-->
<!--									<el-button-->
<!--                      v-if="scope.row.shenpiflag"-->
<!--                      size="small" class="h-tableLink h-btn"-->
<!--                      @click="shenpiopt(scope.row, '')">-->
<!--									审批-->
<!--									</el-button>-->
<!--								</span>-->

                <el-button v-if="scope.row.binstid"
                           size="small" class="h-tableLink h-btn"
                           @click="genzongLiuch(scope.row)">
                  跟踪
                </el-button>
                <el-button
                    size="small" class="h-tableLink h-btn"
                    @click="handelDetail(scope.row)">查看
                </el-button>
                <el-button
                    :key="Math.random()"
                    v-if="scope.row.status == 30"
                    size="small" class="h-tableLink h-btn"
                    @click="sapDeleteOrder2(scope.row)">删除
                </el-button>

<!--                <el-button
                    :key="Math.random()"
                    v-if="(_user.usercode == scope.row.cucode && scope.row.status < 50 ) || adminFlag"
                    size="small" class="h-tableLink h-btn"
                    @click="sapCHOrder(scope.row)">撤回
                </el-button>
                <el-button
                    :key="Math.random()"
                    v-if="scope.row.status >= 40 && scope.row.status <= 41 && scope.row.orderCategory == 2 && scope.row.cashFlag"
                    v-auth="'wx_credit_flag'"
                    size="small" class="h-tableLink h-btn"
                    @click="showCreditFlag(scope.row.sapCode)">信贷标识传递SAP
                </el-button>
                <br/>
                <el-button
                    :key="Math.random()"
                    v-if="scope.row.status > 30 && scope.row.status != 70 &&scope.row.orderCategory == 2"
                    size="small" class="h-tableLink h-btn"
                    @click="printInvoice(scope.row.sapCode)">打印报关发票
                </el-button>
                <el-button
                    :key="Math.random()"
                    v-if="scope.row.status > 30 && scope.row.status != 70  && scope.row.orderCategory == 2"
                    size="small" class="h-tableLink h-btn"
                    @click="printPI(scope.row.sapCode)">打印PI
                </el-button>
                <el-button
                    :key="Math.random()"
                    v-if="scope.row.orderCategory == 2 && scope.row.status != 70 "
                    size="small" class="h-tableLink h-btn" v-auth="'wxdd_pingzhenggl'"
                    @click="opendia(scope.row)">上传凭证
                </el-button>-->
               <!-- <el-button
                    :key="Math.random()"
                    v-if="scope.row.fujianStatus == 1 && scope.row.orderCategory == 2"
                    size="small" class="h-tableLink h-btn"
                    @click="makeInvoice(scope.row.sapCode)">开票
                </el-button>-->

<!--                <el-button-->
<!--                    v-if="scope.row.fujianStatus == 2 && scope.row.orderCategory == 2"-->
<!--                    size="small" class="h-tableLink h-btn"-->
<!--                    @click="writeOff(scope.row.sapCode)">冲销-->
<!--                </el-button>-->

<!--&lt;!&ndash;								<el-button-->
<!--										v-if="scope.row.isAccept == 1 && scope.row.orderCategory == 2 && (scope.row.orderCategory1 == '25' || scope.row.orderCategory1 == '27')"-->
<!--										size="small" class="h-tableLink h-btn"-->
<!--										@click="updateBillBlk(scope.row.id)">申请开票-->
<!--								</el-button>&ndash;&gt;-->
<!--                <el-button-->
<!--                    v-if=" scope.row.orderCategory1 == '41' && scope.row.thawStatus == 'N'"-->
<!--                    size="small" class="h-tableLink h-btn"-->
<!--                    @click="updateBillBlkFw(scope.row)">签收-->
<!--                </el-button>-->
                <el-button
                    v-if="scope.row.orderCategory1 == '41'"
                    size="small" class="h-tableLink h-btn"
                    @click="seeFile(scope.row)">查看附件
                </el-button>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div style="margin-left: 20px;display:flex;justify-content: space-between;margin-top:0.4rem">
            	<div style="float: left;display:flex;align-items: center;">
            		<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" style="padding: 0.1rem 0.20rem"
            		           @click="exportExcel">批量导出
            		</el-button>
<!--                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export" style="padding: 0.1rem 0.20rem"-->
<!--                               @click="uploaddownexcelflagbtn">批量导入-->
<!--                    </el-button>-->
<!--            		<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" style="padding: 0.1rem 0.20rem"-->
<!--            		           @click="printAllInvoice">批量打印报关发票-->
<!--            		</el-button>-->
<!--                  <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" style="padding: 0.1rem 0.20rem"-->
<!--                             @click="printAllInvoiceQG">批量打印清关发票-->
<!--                  </el-button>-->
					<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" style="padding: 0.1rem 0.20rem" v-if="isDateFlag"
							   @click="importAllruhuo">批量上传签收资料
					</el-button>
<!--                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" style="padding: 0.1rem 0.20rem"-->
<!--                               @click="printDraftDeclaration">批量打印报关草单-->
<!--                    </el-button>-->
<!--                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" style="padding: 0.1rem 0.20rem"-->
<!--                               @click="printElements">批量打印申报要素-->
<!--                    </el-button>-->
            	</div>

                <uploaddownexcel
                    :visible.sync="uploaddownexcelflag"
                    v-if="uploaddownexcelflag"
                    clsname="viewOrderImportWxExcel"
                    :startrow="3" @callback="uploadExcelFilecallback"/>

            </div>

            <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:0.4rem">
                <pagination :page="formInline" @query="query"/>
            </div>

    </div>

    <!--附件管理-->
    <el-dialog
        :visible.sync="showFujian"
        v-if="showFujian"
        class="h-dialog2"
    >
      <div class="h-dialogImg">
        <div class="h-disTable">
          <div class="h-tableCell">
            <h1>外销订单凭证总览</h1>
          </div>
        </div>
      </div>
      <div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
        <h3>报关单</h3><h6 v-if="!fjFlag" style="color: red;font-size: 0.14rem;margin-top: 0.1rem;">发货后开放上传</h6>
        <brupload
            style="margin-top: 0.1rem;"
            @filecallback="fjStatus(fjCode)"
            :refid="refid"
            reftype="WXFJ_BGD"
            :uploadflag = "fjFlag"
            delflag/>
        <el-input v-model="customsCode" placeholder="请输入报关单号"
                  style="width: 100%;margin-top: 0.1rem;"></el-input>
      </div>
      <div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
        <h3>入货通知</h3><h6 v-if="!fjFlag" style="color: red;font-size: 0.14rem;margin-top: 0.1rem;">发货后开放上传</h6>
        <brupload
            style="margin-top: 0.1rem;"
            @filecallback="fjStatus(fjCode)"
            :refid="refid"
            reftype="WXFJ_RHTZ"
            :uploadflag = "fjFlag"
            delflag/>
      </div>
      <div class="h-formLine" style="padding:20px;">
        <h3>提单</h3><h6 v-if="!fjFlag" style="color: red;font-size: 0.14rem;margin-top: 0.1rem;">开具发票后开放上传</h6>
        <brupload
            style="margin-top: 0.1rem;"
            :refid="refid"
            reftype="WXFJ_TD"
            :uploadflag = "fjFlag"
            delflag/>
        <div style="display: flex;justify-content: space-between;">
          <el-input v-model="billCode" placeholder="请输入提单号"
                    style="width: 100%;margin-top: 0.1rem;width: 45%;"></el-input>
          <el-date-picker
              placeholder="请选择提单日期"
              v-model="billDate"
              clearable
              type="date"
              value-format="yyyy-MM-dd"
              style="margin-top: 0.1rem;width: 45%;">
          </el-date-picker>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="h-btn h-bBtn h-bgwhite" @click="showFujian = false">取 消</el-button>
        <el-button class="h-btn h-bBtn" @click="submitFujian">提 交</el-button>
      </div>
    </el-dialog>
    <!--附件管理-批量上传入货通知-->
    <el-dialog
        :visible.sync="showFwkaipiao"
        v-if="showFwkaipiao"
        class="h-dialog2"
    >
      <div class="h-dialogImg">
        <div class="h-disTable">
          <div class="h-tableCell">
            <h1>海外标准订单签收</h1>
          </div>
        </div>
      </div>
      <div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
        <h3 style="display: inline-block;">订单号:</h3>
        <h4 style="display: inline-block;margin-left: 0.1rem;line-height: 1.6;">{{ddhB}}</h4>
        <h6 v-if="this.orderFjType1 || this.orderFjType3" style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">请准确上传对应签收资料，单据以“订单号+单据名称”命名，以上信息完整方可签收</h6>
        <h6 v-if="this.orderFjType2" style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">请准确上传对应的合同（合同可以用订单等代替）、发票、运输单据，三项必须完整，单据以“订单号+单据名称”命名，以上信息完整方可签收</h6>
      </div>
      <div class="h-formLine" v-if="this.orderFjType2" style="padding:20px;">
        <h3 style="display: inline-block;">合同</h3>
        <h6 v-if="!fjFlag" style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">(发货后开放上传)</h6>
        <brupload
            style="margin-top: 0.1rem;"
            @filecallback="DJKPStatus"
            :refid="_.join(_.map(this.tableSelectedList,'sapCode'),',')"
            reftype="WXFJ_FWHT"
            :uploadflag = "fjFlag"
            :delflag = "!(this.ks == 'Y')"/>
      </div>
      <div class="h-formLine" v-if="this.orderFjType2" style="padding:20px;">
        <h3 style="display: inline-block;">发票</h3>
        <h6 v-if="!fjFlag" style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">(发货后开放上传)</h6>
        <brupload
            style="margin-top: 0.1rem;"
            @filecallback="DJKPStatus"
            :refid="_.join(_.map(this.tableSelectedList,'sapCode'),',')"
            reftype="WXFJ_FWFP"
            :uploadflag = "fjFlag"
            :delflag = "!(this.ks == 'Y')"/>
      </div>
      <div class="h-formLine" v-if="this.orderFjType2" style="padding:20px;">
        <h3 style="display: inline-block;">运输单据</h3>
        <h6 v-if="!fjFlag" style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">(发货后开放上传)</h6>
        <brupload
            style="margin-top: 0.1rem;"
            @filecallback="DJKPStatus"
            :refid="_.join(_.map(this.tableSelectedList,'sapCode'),',')"
            reftype="WXFJ_YSDJ"
            :uploadflag = "fjFlag"
            :delflag = "!(this.ks == 'Y')"/>
      </div>
      <div class="h-formLine" v-if="this.orderFjType1" style="padding:20px;">
        <h3 style="display: inline-block;">签收资料</h3>
        <h6 v-if="!fjFlag" style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">(发货后开放上传)</h6>
        <brupload
            style="margin-top: 0.1rem;"
            @filecallback="DJKPStatus"
            :refid="_.join(_.map(this.tableSelectedList,'sapCode'),',')"
            reftype="WXFJ_WMQSZL"
            :uploadflag = "fjFlag"
            :delflag = "!(this.ks == 'Y')"/>
      </div>

        <div class="h-formLine" v-if="this.orderFjType3" style="padding:20px;">
            <h3 style="display: inline-block;">签收资料</h3>
            <h6 v-if="!fjFlag" style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">(发货后开放上传)</h6>
            <brupload
                    style="margin-top: 0.1rem;"
                    @filecallback="DJKPStatus"
                    :refid="_.join(_.map(this.tableSelectedList,'sapCode'),',')"
                    reftype="WXFJ_WMFWQSZL"
                    :uploadflag = "fjFlag"
                    :delflag = "!(this.ks == 'Y')"/>
        </div>
<!--      <div class="h-formLine" style="width:200px;padding:20px;">
        <h3 style="display: inline-block;">签收时间</h3>
        <el-date-picker
            v-model="date1"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>-->
      <div slot="footer" class="dialog-footer">
        <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取 消</el-button>
        <el-button class="h-btn h-bBtn" @click="submitFujianC">提 交</el-button>
      </div>
    </el-dialog>

    <!--附件管理-查看/下载全部附件-->
    <el-dialog
        :visible.sync="showFujianD"
        v-if="showFujianD"
        class="h-dialog2"
    >
      <div class="h-dialogImg">
        <div class="h-disTable">
          <div class="h-tableCell">
            <h1>订单签收资料</h1>
          </div>
        </div>
      </div>
      <div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
        <h3 style="display: inline-block;">订单号:</h3>
        <h4 style="display: inline-block;margin-left: 0.1rem;">{{ddhU}}</h4>
        <h6 v-if="this.orderFjType1 || this.orderFjType3" style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">请准确上传对应签收资料，单据以“订单号+单据名称”命名，以上信息完整方可签收</h6>
        <h6 v-if="this.orderFjType2" style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">请准确上传对应的合同（合同可以用订单等代替）、发票、运输单据，三项必须完整，单据以“订单号+单据名称”命名，以上信息完整方可签收</h6>
      </div>
      <div class="h-formLine" v-if="this.orderFjType2" style="padding:20px;border-bottom: 1px dashed #ccc;">
        <h3 style="display: inline-block;">合同</h3>
        <h6 v-if="!fjFlag" style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">(发货后开放上传)</h6>
        <brupload
            style="margin-top: 0.1rem;"
            @filecallback="DJKPStatus"
            :refid="refid"
            reftype="WXFJ_FWHT"
            :uploadflag = "fjFlag"
            :delflag = "!(this.ks == 'Y')"/>
      </div>
      <div class="h-formLine" v-if="this.orderFjType2" style="padding:20px;">
        <h3 style="display: inline-block;">发票</h3>
        <h6 v-if="!fjFlag" style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">(发货后开放上传)</h6>
        <brupload
            style="margin-top: 0.1rem;"
            @filecallback="DJKPStatus"
            :refid="refid"
            reftype="WXFJ_FWFP"
            :uploadflag = "fjFlag"
            :delflag = "!(this.ks == 'Y')"/>
      </div>
      <div class="h-formLine" v-if="this.orderFjType2" style="padding:20px;">
        <h3 style="display: inline-block;">运输单据</h3>
        <h6 v-if="!fjFlag" style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">(发货后开放上传)</h6>
        <h6 style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">6200销售订单必须上传运输单据方可签收，外销服务订单不需上传</h6>
        <brupload
            style="margin-top: 0.1rem;"
            @filecallback="DJKPStatus"
            :refid="refid"
            reftype="WXFJ_YSDJ"
            :uploadflag = "fjFlag"
            :delflag = "!(this.ks == 'Y')"/>
      </div>
      <div class="h-formLine" v-if="this.orderFjType1" style="padding:20px;">
        <h3 style="display: inline-block;">签收资料</h3>
        <brupload
            style="margin-top: 0.1rem;"
            @filecallback="DJKPStatus"
            :refid="refid"
            reftype="WXFJ_WMQSZL"
            :uploadflag = "fjFlag"
            :delflag = "!(this.ks == 'Y')"/>
      </div>
        <div class="h-formLine" v-if="this.orderFjType3" style="padding:20px;">
            <h3 style="display: inline-block;">签收资料</h3>
            <h6 v-if="!fjFlag" style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">(发货后开放上传)</h6>
            <brupload
                    style="margin-top: 0.1rem;"
                    @filecallback="DJKPStatus"
                    :refid="refid"
                    reftype="WXFJ_WMFWQSZL"
                    :uploadflag = "fjFlag"
                    :delflag = "!(this.ks == 'Y')"/>
        </div>
      <div class="h-formLine" style="width:200px;padding:20px;">
        <h3 style="display: inline-block;">签收时间</h3>
        <el-date-picker
            v-model="date1"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
      <!--			<div slot="footer" class="dialog-footer">
              <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取 消</el-button>
              <el-button class="h-btn h-bBtn" @click="submitFujianC">提 交</el-button>
            </div>-->
    </el-dialog>
    <!--创建订单弹出框-->
    <dingdadd :visible.sync="imgflag3" v-if="imgflag3" @imgfalse3="imgflag3=false"/>

    <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>


    <el-dialog :close-on-click-modal="false" title="作废订单" :visible.sync="zfyydialogFormVisible">
      <el-form :model="zuofeiyy">
        <el-form-item label="作废原因" :label-width="100" :rules="[
                  { required: true},
                ]">
          <brselect category="DD_ZFYY" :v="zuofeiyy.yy"
                    v-model="zuofeiyy.yy" ></brselect>
        </el-form-item>
        <el-form-item label="备注" :label-width="100">
          <el-input v-model="zuofeiyy.bz" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取 消</el-button>
        <el-button class="h-btn h-bBtn" @click="submitzuofei">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" title="撤回订单" :visible.sync="chehuidialogFormVisible">
      <el-form :model="zuofeiyy">
        <el-form-item label="撤回原因" :rules="[
                  { required: true},
                ]">
          <brselect category="DD_ZFYY" :v="zuofeiyy.yy"
                    v-model="zuofeiyy.yy" ></brselect>
        </el-form-item>
        <el-form-item label="备注"   :rules="[
                  { required: true},
                ]">
          <el-input v-model="zuofeiyy.bz" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="撤单申请书" class="h-elformWrap-2" >
          <brupload
              :refid="refid"
              reftype="订单-撤单申请书"
              :limit="1"
              :showtime="false"
              uploadflag
              delflag
          >
          </brupload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取 消</el-button>
        <el-button class="h-btn h-bBtn" @click="chehui">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" title="信贷标识传递SAP" :visible.sync="wxCreditFlag">
      <el-form :model="creditFlagModel">
        <el-form-item label="订单编号" >
          <el-input v-model="creditFlagModel.sapCode" style="width:30%" readonly></el-input>
        </el-form-item>
        <el-form-item label="信用检查" >
          <el-select v-model="creditFlagModel.flag" style="width:30%" clearable placeholder="请选择">
            <el-option value="Y" label="通过" key="Y"></el-option>
            <el-option value="N" label="不通过" key="N"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="h-btn h-bBtn h-bgwhite" @click="wxCreditFlag = false">取 消</el-button>
        <el-button class="h-btn h-bBtn" @click="submitCreditFlag">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ss from '../../api/SystemService'
import updownfile from '../../utils/updownfile';
import uploaddownexcel from '../../components/uploaddown/uploaddownexcel'
import engTable from '../../api/dingd/ProductEngTable'


export default {
  props: ["firstPageFlag"],
  components: {
    uploaddownexcel,
  },
  data() {
    return {
      // 展开折叠筛选
      wxCreditFlag:false,
      creditFlagModel:{
        sapCode:"",
        flag:""
      },
      date1: '',
      ddhB: '',
      showKaipiao: null,
      showFwkaipiao: null,
      isDateFlag: false,
      ks: "N",
      showFujianD: false,
      isScreen:false,
      closeScreen:require("@/assets/images/pimg/closeallic.png"),
      drawScreen:require("@/assets/images/pimg/dobleArr.png"),
      adminFlag:false,
      //撤回
      chehuidialogFormVisible: false,
      //导入Excel
      uploaddownexcelflag: false,

      fjFlag: null,
      typeFlag: null,
      fjCode: null,
      id: null,
      fhStatus: null,
      refid: null,
      reftype: null,
      showFujian: null,
      orderFjType: false,
      orderFjType1: false,
      orderFjType2: false,
      orderFjType3: false,

      instid: null,
      showhistory: null,

      imgflag3: false,
      orderTypeList: [],
      orderCategory1AllList:[],
      orderCategory1List:[],

      tableData: [],
      //用户项目
      allProjectByUser: [],
      //是否有项目
      xiangmuTab: false,
      //销售组织，下拉
      xszz: [],
      fxqd: [],
      //表单
      formInline: {
        pageSize: 20,
        pageNo: 1,
        total: 0,
        ownShenpiFlag: false,
        fujianStatusFlag: false,
        ownShenpi: '',
        fujianStatus: '',
        cuserCodeNameLike: "",
        sdfCodeNameLike: "",
        orderCategory1:'41',
        materialCodeNameLike: "",
        orderCategory: "2",
        saleGroupCode: "",
        status: "",
        cdatebegin:null,
        cdateend:null,
        orderTypebz: 2,
        shouhuoflag:null,
        shipToAreaCode: null,
        dqcode: null,
        isUsa:true,
      },
      kaipiao: {
        id:null,
        acceptTime:null,
        sapCode:null,
      },
      fujian: {
        id:null,
        acceptTime:null,
        sapCode:null,
      },

      customsCode: null,
      billCode: null,
      billDate: null,
      sapCode:null,

      spanArr: [],
      idList: [],
      //作废原因
      zfyydialogFormVisible:false,
      zuofeiyy:{
        id:null,
        yy:null,
        bz:null,
        type:null,
        orderStatus:null,
      },

      tableSelectedList:[],
      shipToAreaCodeList:[],
      dqcodeList:[],

    }
  },

  created() {
    this.adminFlag = this.$store.getters.hasRole('swyl_admin');
    this.formInline.orderCategory = 2;
    this.query();
    this.isDate();
    this.orderCategory1AllList=this.$store.getters.dictlist("xiaoshou_quyu_nwx");
    this.orderCategory1List =  _.filter(this.orderCategory1AllList,{pid:'20191025hQ7mNd95'});
    //    项目
    //     this.listPro();

    //获取所属大区列表
    ss.OrderMainService.getDq().then(rd => {
      this.dqcodeList = rd;
      console.log("dqcodeList", this.dqcodeList);
    });

  },
  methods: {
    getdatatime(){//默认显示今天
      this.date1= new Date();
    },
    showCreditFlag(sapCode){
      this.wxCreditFlag = true;
      this.creditFlagModel.sapCode = sapCode;
    },
    submitCreditFlag(){
      ss.OrderMainService.submitCreditFlag(this.creditFlagModel).then(rd=>{
        if (rd.f){
          this.$msg.msgs("传递SAP成功");
          this.wxCreditFlag = false;
        }
      })
    },
    // 展开折叠
    collapseChange(){
      this.isScreen = !this.isScreen;
    },

    changeDqCate(cate){
      if(cate){
        console.log("cate", cate);
        //获取国家列表
        ss.OrderMainService.getGj(cate).then(rd => {
          //console.log("areaList", rd);
          this.shipToAreaCodeList = rd;
        });
      }else{
        this.shipToAreaCodeList =  [];
      }
    },

    //撤回订单
    sapCHOrder(row) {
      this.$msg.confirm("确认从SAP作废并撤回订单?", () => {
        this.zuofeiyy.id = row.bid;
        this.chehuidialogFormVisible = true;
        this.refid = row.bid;
        this.zuofeiyy.type = row.orderCategory;
        this.zuofeiyy.orderStatus = row.status;
      });
    },
    chehui(){
      if (!this.zuofeiyy.yy) {
        this.$msg.msge("请选择撤回原因");
        return false;
      }
      if (!this.zuofeiyy.bz) {
        this.$msg.msge("请填写撤单备注");
        return false;
      }
      var yybz = this.zuofeiyy.yy+":"+this.$store.getters.dictname("DD_ZFYY",this.zuofeiyy.yy)+":"+this.zuofeiyy.bz;
      this.$msg.confirm("确认撤回?", () => {
        ss.OrderMainService.sapCHOrder(this.zuofeiyy.id, yybz, this.zuofeiyy.type,this.zuofeiyy.orderStatus).then(rd => {
          this.$msg.msgs(rd.msg);
          this.query();
          this.chehuidialogFormVisible = false;
          this.zuofeiyy = {
            id:null,
            yy:null,
            bz:null,
            type:null,
          };
        });
      });
    },
    //导入Excel
    uploaddownexcelflagbtn() {
      this.uploaddownexcelflag = true;
    },
    uploadExcelFilecallback(rd) {
      this.query();
      this.$msg.msgs(rd.msg);
    },

    changeOrderCate(cate){
      if(cate){
        this.orderCategory1List =  _.filter(this.orderCategory1AllList,{pid:cate.id});
      }else{
        this.orderCategory1List =  [];
      }

    },
    //批量上传入货单
    importAllruhuo() {
      if(this.ddhB == ''){
        this.$msg.msge("请勾选以上订单!!!");
        return false;
      }
      var flag1 = false
      var flag2 = false
      var flag3 = false
      var orderTypeChild = this.tableSelectedList[0].orderCategory1;
      this.tableSelectedList.forEach((item, index) => {
        if(item.status < 40){
          flag1 = true;
          return;
        }
      })

      if(flag1){
        this.$msg.msge("审核通过后的正常订单才能上传入货单,请重新选择!");
        return;
      }
      if(flag3){
        this.$msg.msge("只能选择同一类型的订单！");
        return;
      }
      this.fjFlag = true;
      this.orderFjType1 = true;
      this.tableSelectedList.forEach((item, index) => {
        if(item.status < 40){
          this.fjFlag = false;
        }
        if(item.thawStatus == 'Y'){
          this.ks = 'Y';
        }else{
          this.ks = 'N';
        }
      })
      this.date1 = new Date();
      console.log("测试订单类型",this.orderFjType);
      this.showFwkaipiao = true;
    },
    importAllruhuoOne(v) {
      if(this.ddhB == ''){
        this.$msg.msge("请勾选以上订单!!!");
        return false;
      }
      var flag1 = false
      var flag2 = false
      var flag3 = false
      var orderTypeChild = this.tableSelectedList[0].orderCategory1;
      this.tableSelectedList.forEach((item, index) => {
        if(item.status < 40){
          flag1 = true;
          return;
        }
      })

      if(flag1){
        this.$msg.msge("审核通过后的正常订单才能上传入货单,请重新选择!");
        return;
      }
      if(flag3){
        this.$msg.msge("只能选择同一类型的订单！");
        return;
      }
      this.fjFlag = true;
      this.orderFjType1 = true;
      this.tableSelectedList.forEach((item, index) => {
        if(item.status < 40){
          this.fjFlag = false;
        }
        if(item.thawStatus == 'Y'){
          this.ks = 'Y';
        }else{
          this.ks = 'N';
        }
      })
      this.date1 = new Date();
      console.log("测试订单类型",this.orderFjType);
      this.showFwkaipiao = true;
    },
    //批量上传入货单
    uploadYsFile() {
      if(this.ddhB == ''){
        this.$msg.msge("请勾选以上订单!!!");
        return false;
      }
      var flag1 = false
      var flag2 = false
      var flag3 = false
      var orderTypeChild = this.tableSelectedList[0].orderCategory1;
      this.tableSelectedList.forEach((item, index) => {
        if(item.status < 40){
          flag1 = true;
          return;
        }
        if(item.orderCategory1 != orderTypeChild){
          flag3 = true;
          return;
        }
      })

      if(flag1){
        this.$msg.msge("审核通过后的正常订单才能上传入货单,请重新选择!");
        return;
      }
      if(flag3){
        this.$msg.msge("只能选择同一类型的订单！");
        return;
      }
      this.fjFlag = true;
      this.tableSelectedList.forEach((item, index) => {
        if(item.status < 40){
          this.fjFlag = false;
        }
        if(item.thawStatus == 'Y'){
          this.ks = 'Y';
        }else{
          this.ks = 'N';
        }
      })
      this.date1 = new Date();
      this.handleSelectionChange(this.tableSelectedList);
      this.showFwkaipiao = true;
    },
    seeFile(o) {
      this.fjFlag = o.status < 40 ? false : true;
      this.fjCode = o.sapCode;
      this.id = o.id;
      this.fhStatus = o.status;
      this.bS = o.billingStatus;
      this.refid = this.ddhU = o.sapCode;
      this.fujian.id = o.id;
      this.fujian.sapCode = o.sapCode;
      this.fujian.acceptTime = o.acceptTime;
      console.log('查看附件',this.orderFjType2);
      if(o.thawStatus == 'Y'){
        this.ks = 'Y'
        this.fjFlag = false
      }else{
        this.ks = 'N'
      }
      console.log('查看附件1',this.orderFjType2);
      //附件类型展示条件
      this.orderFjType1 = true;
      console.log('查看附件2',this.orderFjType2);
      this.date1 = o.acceptTime;
      console.log('查看附件3',this.orderFjType2);
      this.showFujianD = true;
    },
    submitFujianC(){
      var flag3 = false
      var sapCodes = []
      for(var i = 0;i < this.tableSelectedList.length;i++){
        this.tableSelectedList[i].acceptTime = this.date1;
        var obj = this.tableSelectedList[i];
        sapCodes.push(obj);
      }

      ss.OrderMainService.DingdUsaQs(sapCodes).then(rd => {
        if(rd.f == true){
          this.$msg.msgs(rd.msg);
          this.query();
          this.showFwkaipiao = false;
          this.orderFjType = false;
          this.orderFjType1 = false;
          this.orderFjType2 = false;
        }
      });
      /*ss.OrderMainService.getKpStatus(saps).then(rd => {
        if(rd.msg==1){
          flag3 = true;
        }
        if(!flag3){
          this.$msg.msgs("上传开票资料成功");
          this.query();
          this.showFwkaipiao = false
        }else{
          //申请解冻开票
          var ids = [];
          this.tableSelectedList.forEach((item, index) => {
            this.kaipiao.id = item.id;
            this.kaipiao.acceptTime = this.date1;
            ids.push(this.kaipiao)
          })
          console.log("ceshishice",ids)
          this.idList = ids;
          ss.OrderMainService.updateBillBlk(this.idList).then(rd => {
            if(rd.f == true){
              this.$msg.msgs("解冻开票成功！");
              this.query();
              this.showFwkaipiao = false
            }
          });

        }
      });*/
    },
    DJKPStatus() {
      // var saps = _.join(_.map(this.tableSelectedList,"sapCode"),",");
      var ids = [];
      var form = {};
      var obj = null;
      console.log("选中查看",this.tableSelectedList);
      /*                this.tableSelectedList.forEach((item, index) => {
                          item.acceptTime = date1
                          // form.id = item.id;
                          // form.sapCode = item.sapCode;
                          // form.acceptTime = this.date1;
                          ids.push(item);
                      })
                      console.log('ids', ids);*/
      for(var i = 0;i < this.tableSelectedList.length;i++){
        this.tableSelectedList[i].acceptTime = this.date1;
        var obj = this.tableSelectedList[i];
        ids.push(obj);
        console.log('ids', obj);
      }
      console.log('ids', obj);
      /*				this.kaipiao.sapCode = this.fjCode;
              this.kaipiao.acceptTime = this.date1;
              this.kaipiao.id = this.id;
              ids.push(this.kaipiao)*/
      ss.OrderMainService.updateKpStatus(ids).then(rd => {
        if(rd.f == true){
          // this.$msg.msgs("操作成功！");
          // this.query();
          // this.showFwkaipiao = false
        }
      });
    },
    //批量导出
    exportExcel() {
      var strids = _.join(_.map(this.tableSelectedList,"id"),",");
      var form = {
        pageSize: 20,
        pageNo: 1,
        total: 0,

        ownShenpiFlag: false,
        fujianStatusFlag: false,
        ownShenpi: '',
        fujianStatus: '',
        cuserCodeNameLike: "",
        sdfCodeNameLike: "",
        materialCodeNameLike: "",
        orderCategory: "2",
        saleGroupCode: "",
        status: "",
        cdatebegin:null,
        cdateend:null,
        orderTypebz: 2,
        shouhuoflag:null,
        shipToAreaCode: null,
        dqcode: null,
        isUsa:true,
      };
      if (strids == '') {
        form = _.clone(this.formInline);
      }
      form.strids = strids;
      updownfile.down("/api/swyl/v1/demo/viewOrder/downloadExcel", form, "post");
    },
    //批量导出箱单发票Excel
    printAllInvoice() {
      var flag1 = false
      var flag2 = false
      this.tableSelectedList.forEach((item, index) => {
        if(!(item.status > 30 && item.status != 70 && item.orderCategory == 2)){
          flag1 = true;
          return;
        }
      })
      var newList = _.uniqBy(this.tableSelectedList, "soldToCode");
      if(newList.length > 1){
        flag2 = true;
      }
      if(flag1){
        this.$msg.msge("审核通过后的正常订单才能打印箱单发票,请重新选择!");
        return;
      }
      if(flag2){
        this.$msg.msge("所选订单中存在不同送达方,请重新选择!");
        return;
      }
      var strids = _.join(_.map(this.tableSelectedList,"sapCode"),",");
      this.$msg.confirm("确认打印?", () => {

        engTable.checkByMaterialCode({sapIds:strids}).then(rd => {
            ss.OrderMainService.groupByFactory({sapIds:strids}).then(rt => {
                if (rt.f) {
                    var codeList = rt.msg;
                    console.log("12312313123123", codeList)
                    for (var i = 0; i < codeList.length; i++) {
                        if (rd.msg !="") {

                            if(rd.msg.indexOf("产品编号")!=-1){
                                this.$alert(rd.msg, '提示', {
                                    confirmButtonText: '确定',
                                    type:'warning',
                                    callback: action => {
                                        updownfile.down('/api/swyl/v1/dingdmain/printAllInvoice',{sapIds:codeList[i]},"post");
                                    }
                                });
                            }else if(rd.msg.indexOf("订单编号")!=-1){
                                this.$alert(rd.msg, '提示', {
                                    confirmButtonText: '确定',
                                    type:'error',
                                    callback: action => {
                                        updownfile.down('/api/swyl/v1/dingdmain/printAllInvoice',{sapIds:codeList[i]},"post");
                                    }
                                });
                            }
                        } else {
                            updownfile.down('/api/swyl/v1/dingdmain/printAllInvoice',{sapIds:codeList[i]},"post");
                        }
                    }
                }
            })
        })

      });
    },
    //批量导出清关发票Excel
    printAllInvoiceQG() {
          var flag1 = false
          var flag2 = false
          this.tableSelectedList.forEach((item, index) => {
              if(!(item.status > 30 && item.status != 70 && item.orderCategory == 2)){
                  flag1 = true;
                  return;
              }
          })
          var newList = _.uniqBy(this.tableSelectedList, "soldToCode");
          if(newList.length > 1){
              flag2 = true;
          }
          if(flag1){
              this.$msg.msge("审核通过后的正常订单才能打印箱单发票,请重新选择!");
              return;
          }
          if(flag2){
              this.$msg.msge("所选订单中存在不同送达方,请重新选择!");
              return;
          }
          var strids = _.join(_.map(this.tableSelectedList,"sapCode"),",");
          this.$msg.confirm("确认打印?", () => {

              engTable.checkByMaterialCode({sapIds:strids}).then(rd => {

                  if (rd.msg !="") {

                      if(rd.msg.indexOf("产品编号")!=-1){
                          this.$alert(rd.msg, '提示', {
                              confirmButtonText: '确定',
                              type:'warning',
                              callback: action => {
                                  updownfile.down('/api/swyl/v1/dingdmain/printAllInvoiceQG',{sapIds:strids},"post");
                              }
                          });
                      }else if(rd.msg.indexOf("订单编号")!=-1){
                          this.$alert(rd.msg, '提示', {
                              confirmButtonText: '确定',
                              type:'error',
                              callback: action => {
                                  updownfile.down('/api/swyl/v1/dingdmain/printAllInvoiceQG',{sapIds:strids},"post");
                              }
                          });
                      }
                  } else {
                      updownfile.down('/api/swyl/v1/dingdmain/printAllInvoiceQG',{sapIds:strids},"post");
                  }

              })

          });
      },
    //导出箱单发票Excel
    printInvoice(x) {
      this.$msg.confirm("确认打印?", () => {
        engTable.checkByMaterialCode({sapIds:x}).then(rd => {
            if (rd.msg !="") {
                if(rd.msg.indexOf("产品编号")!=-1){
                    this.$alert(rd.msg, '提示', {
                        confirmButtonText: '确定',
                        type:'warning',
                        callback: action => {
                            updownfile.down('/api/swyl/v1/dingdmain/printInvoice',{sapId:x},"post");
                        }
                    });
                }else if(rd.msg.indexOf("订单编号")!=-1){
                    this.$alert(rd.msg, '提示', {
                        confirmButtonText: '确定',
                        type:'error',
                        callback: action => {
                            updownfile.down('/api/swyl/v1/dingdmain/printInvoice',{sapId:x},"post");
                        }
                    });
                }
            } else {
                updownfile.down('/api/swyl/v1/dingdmain/printInvoice',{sapId:x},"post");
            }
        })
        // ss.OrderMainService.printInvoice(x).then(rd => {
        //     this.$msg.msgs(rd.msg);
        // });
      });
    },

    //导出箱单发票Excel
    printPI(x) {
      this.$msg.confirm("确认打印?", () => {
        updownfile.down('/api/swyl/v1/dingdmain/printPI',{sapId:x},"post");
      });
    },
    ownShenpiFlag(){
      if(this.formInline.ownShenpiFlag){
        this.formInline.ownShenpi = '1';
      }else {
        this.formInline.ownShenpi = '';
      }
      console.log('我在这儿呀', this.formInline.ownShenpi);
    },

    fujianStatusFlag(){
      if(this.formInline.fujianStatusFlag){
        this.formInline.fujianStatus = '2';
      }else {
        this.formInline.fujianStatus = '';
      }
      console.log('我在这儿呀', this.formInline.fujianStatus);
    },

    //财务收货
    caiwushouhuo(){
      console.log(this.tableSelectedList)
      if(this.tableSelectedList.length == 0){
        this.$msg.msge("至少选中一条操作！");
        return false;
      }
      var shlist = [];
      for(var i=0;i<this.tableSelectedList.length;i++){
        var obj = this.tableSelectedList[i];

        if( obj.status!='40'){
          this.$msg.msge("选中的订单状态不对，只有审核通过的才能执行收货操作！");
          return false;
        }else{
          shlist.push(obj);
        }
      }
      ss.OrderMainService.updateShouhuoflag(_.join(_.map(shlist,"bid"),",")).then(rd=>{
        this.$refs['ddtable'].clearSelection();
        this.$msg.msgs("更新收货状态成功！");
        this.query();
      })
    },
    handleSelectionChange(lists){
      this.tableSelectedList = lists;
      var str = '';
      for(var i=0;i<lists.length;i++){
        str += lists[i].sapCode + ',';
      }
      str = str.substring(0,str.length-1);
      this.ddhB = str;
    },
    //附件管理
    opendia(o) {
      this.fjFlag = o.status < 40 ? false : true;
      this.fjCode = o.sapCode;
      this.id = o.id;
      this.fhStatus = o.status;
      console.log('我在这儿呀', o.status);
      this.refid = o.sapCode;
      this.showFujian = true;
    },
    fjStatus(x) {
      ss.OrderMainService.updateFjStatus(x).then(rd => {
      });
    },

    //判断当前日期是否在允许签收的时间范围之内
    isDate(){
      ss.OrderMainService.isDate().then(rd =>{
        this.isDateFlag = rd.msg;
      })
    },

    getSpanArr() {
      this.spanArr = [];
      this.tableData.forEach((item, index) => {
        if (index === 0) {
          this.spanArr.push(1);
          this.position = 0;
        } else {
          if (this.tableData[index].id === this.tableData[index - 1].id) {
            this.spanArr[this.position] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.position = index;
          }
        }
      })
    },
    objectSpanMethod({row, column, rowIndex, columnIndex}) {
      if (
          (
              columnIndex == 0 && row.orderCategory == '2'
          )
          ||
          (
              /*  (columnIndex >= 5 && columnIndex <= 14 || columnIndex >= 16 && columnIndex <= 17 || columnIndex >= 20 && columnIndex <= 23 || columnIndex >= 27 && columnIndex <= 29) && column.label != '订单状态'
                && column.label != '销售组织' && column.label != '数量' && column.label != '成交价' && column.label != '总价'
    && column.label != '改制加价' && column.label != '改制描述'  && column.label != '运费' && column.label != '保费'
*/
              column.label == '订单状态' || column.label == '订单类型' || column.label == '售达方编码' || column.label == '售达方名称' || column.label == '售达方地区'
              || column.label == '币种编码' || column.label == '订单总价'|| column.label == 'RMB总价' || column.label == '不含税总价' || column.label == '客户渠道' || column.label == '项目名称' || column.label == '创建人名称'

          )
          ||
          (
              column.label == '订单号' && row.orderCategory == '2' && row.orderCategory1 != '26'
          )
          ||
          (
              (column.label == '订单状态' || column.label == '操作') &&
              (row.status == '10' || row.orderCategory == '2') && row.orderCategory1 != '26'
          )
      ) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },
    genzongLiuch(r) {
      console.log(r);
      if (r.orderCategory == '1' || r.orderCategory == '3' || r.orderCategory1 == '26' || r.orderCategory1 == '30') {
        this.instid = r.binstid;
      } else {
        this.instid = r.instid;
      }
      this.showhistory = true;
    },
    genzongLiuch1(r) {
      this.instid = r.killInstid;
      this.showhistory = true;
    },
    imgfalse3() {
      this.imgflag3 = true;
    },
    //查询该用户及所有子用户所有订单详情
    query() {
      ss.OrderMainService.selectUsaPage(this.formInline).then(rd => {
        this.tableData = rd.records;
        //console.log('tableData', this.tableData);
        this.formInline.total = rd.total || 0;
        this.getSpanArr();
      });
    },
    submitSap(id){
      var data = {};
      data.id = id
      ss.OrderMainService.submitOrderSap(data).then(rd => {
        this.$msg.msgs("推送成功！")
        this.query();
      })
    },
    submitSapOld(id){
      var data = {};
      data.id = id
      ss.OrderMainService.submitOrderSapOld(data).then(rd => {
        this.$msg.msgs("推送成功！")
        this.query();
      })
    },
    submitSapPass(id){
      var data = {};
      data.id = id
      ss.OrderMainService.submitOrderSapPass(data).then(rd => {
        this.$msg.msgs("推送成功！")
        this.query();
      })
    },
    shenpiopt(row, flag){
      var instid = null;
      if (row.orderCategory == '1') {
        instid = row.binstid;
      } else {
        instid = row.instid;
      }
      //解决业务主人提报 报任务已经办理问题 hyl
      var ywid = null;
      if ((row.orderCategory1 == '21' || row.orderCategory1 == '24') && row.status !='71' && row.status !='73') {
        ywid = row.id;
      } else {
        ywid = row.bid;
      }

      this.$router.push({
        path: row.dburl,
        query: {ywid: ywid,taskid:row.taskid, instid: instid, taskstatus: '0', chongXinTiJiao: flag}
      })
    },
    //检索
    handleFilter() {
      this.formInline.pageNo = 1;
      this.query();
    },

    // 重置按钮
    resetData() {
      this.formInline.sapCode = "";
      this.formInline.ownShenpiFlag = false;
      this.formInline.fujianStatusFlag = false;
      this.formInline.ownShenpi = "";
      this.formInline.fujianStatus = "";
      this.formInline.cuserCodeNameLike = "";
      this.formInline.sdfCodeNameLike = "";
      this.formInline.materialCodeNameLike = "";
      this.formInline.orderCategory = "";
      this.formInline.orderCategory1 = "";
      this.formInline.saleGroupCode = "";
      this.formInline.status = "";
      this.formInline.cdatebegin = null;
      this.formInline.cdateend = null;
      this.formInline.orderTypebz = 2;
      this.formInline.shouhuoflag = null;
      this.formInline.shipToAreaCode = null;
      this.formInline.dqcode = null;
      this.formInline.chandidata = "";
    },


    handleEdit(row) {
      console.log(row)
      this.toEdit(row.orderCategory, row.orderCategory1, row.id);
      // this.$router.push({path: "/dingd/createOrder", query: {id:row.id}})
    },
    handelDetail(row) {
      var instid = null;
      if (row.orderCategory == '1' || row.orderCategory1 == '26') {
        instid = row.binstid;
      } else {
        instid = row.instid;
      }
      // if (row.orderCategory == '1' || row.orderCategory == '3') {
      //     this.$router.push({
      //         path: "/dingdmain/orderNxshenpi",
      //         query: {id: row.bid, instid: instid, taskstatus: '1', f: '1'}
      //     })
      // } else {
      //     this.$router.push({
      //         path: "/dingdmain/orderWxshenpi",
      //         query: {id: row.bid, instid: instid, taskstatus: '1', f: '1'}
      //     })
      // }
      let pathsp = row.orderCategory1 == '26' ? "/dingdmain/orderNxshenpi" : "/dingdmain/orderWxUsashenpi";
      if(row.orderCategory1 == '28'){
        pathsp = "/dingdmain/orderWxToHKshenpi";
      }
      this.$router.push({
        path: pathsp,
        query: {id: row.bid, instid: instid, taskstatus: '1', f: '1'}
      });
    },


    //开票
    makeInvoice(x) {
      this.$msg.confirm("确认开票?", () => {
        ss.OrderMainService.makeInvoice(x).then(rd => {
          this.$msg.msgs(rd.msg);
        });
      });
    },

    //冲销
    writeOff(x) {
      this.$msg.confirm("确认冲销?", () => {
        ss.OrderMainService.writeOff(x).then(rd => {
          this.$msg.msgs(rd.msg);
        });
      });
    },

    //申请解冻开票
    updateBillBlk(x) {
      var ids = [];
      ids.push(x);
      this.idList = ids;
      this.$msg.confirm("确认申请开票?", () => {
        ss.OrderMainService.updateBillBlk(this.idList).then(rd => {
          this.$msg.msgs(rd.msg);
        });
      });
    },

    cancel() {
      this.zuofeiyy = {
        id:null,
        yy:null,
        bz:null,
        type:null,
      };
      this.zfyydialogFormVisible = false;
      this.chehuidialogFormVisible = false;
      this.showFwkaipiao = false;
      this.orderFjType = false;
      this.orderFjType1 = false;
      this.orderFjType2 = false;
      // this.showFujianD = false;
    },

    //作废订单
    sapDeleteOrder(row) {
      if (row.status == '10') {
        this.$msg.confirm("确认作废?", () => {
          ss.OrderMainService.sapDeleteOrder(row.bid, row.deleteReason).then(rd => {
            this.$msg.msgs(rd.msg);
            this.query();
          });
        });
      } else {
        this.zuofeiyy.id = row.bid
        this.zfyydialogFormVisible = true;
      }
    },

    //删除订单
    sapDeleteOrder2(row) {
      if (row.status == '10' || row.status == '30') {
        this.$msg.confirm("确认删除?", () => {
          ss.OrderMainService.sapDeleteOrder2(row.bid, row.deleteReason).then(rd => {
            this.$msg.msgs(rd.msg);
            this.query();
          });
        });
      } else {
        this.zuofeiyy.id = row.bid
        this.zfyydialogFormVisible = true;
      }
    },

    submitzuofei(){
      if (!this.zuofeiyy.yy) {
        this.$msg.msge("请选择作废原因");
        return false;
      }
      if (!this.zuofeiyy.bz) {
        this.$msg.msge("作废备注必填");
        return false;
      }
      var yybz = this.zuofeiyy.yy+":"+this.$store.getters.dictname("DD_ZFYY",this.zuofeiyy.yy)+":"+this.zuofeiyy.bz;
      this.$msg.confirm("确认作废?", () => {
        ss.OrderMainService.sapDeleteOrder(this.zuofeiyy.id, yybz).then(rd => {
          this.$msg.msgs(rd.msg);
          this.query();
          this.zfyydialogFormVisible = false;
          this.zuofeiyy = {
            id:null,
            yy:null,
            bz:null,
            type:null,
          };
        });
      });
    },

    submitFujian(){
      var orderM = {
        id : this.id,
        customsCode : this.customsCode,
        billCode : this.billCode,
        billDate : this.billDate
      };
      //console.log('orderM', orderM);
      ss.OrderMainService.updateByModel(orderM).then(rd => {
        this.$msg.msgs(rd.msg);
        this.query();
        this.showFujian = false
      });
    },

    toEdit(ddlx, ddzlx, id) {
      if (ddlx == '1') {
        if (ddzlx == '9') {
          //服务订单
          this.$router.push({path: "/dingd/createFuwuOrder", query: {id: id}})
          return;
        }
        this.$router.push({path: "/dingd/createNxOrder", query: {id: id}})
      } else if (ddlx == '2') {
        //外销
        if (ddzlx == '25') {
          //服务订单
          this.$router.push({path: "/dingd/createWxFuwuOrder", query: {id: id}})
          return;
        }
        if (ddzlx == '26') {
          //外贸订单
          this.$router.push({path: "/dingd/createWMOrder", query: {id: id}})
          return;
        }
        if (ddzlx == '27') {
          //外贸订单
          this.$router.push({path: "/dingd/createBeiHuoOrder", query: {id: id}})
          return;
        }
        if (ddzlx == '28') {
          //9390或者9370卖给6200的销售订单
          this.$router.push({path: "/dingd/createHKOrder", query: {id: id}})
          return;
        }
        if (ddzlx == '29') {
          //6200免费订单
          this.$router.push({path: "/dingd/createWxOrder6200", query: {id: id}})
          return;
        }
          if (ddzlx == '30') {
              //6200免费订单
              this.$router.push({path: "/dingd/createWMFWOrder", query: {id: id}})
              return;
          }
          if(ddzlx == '41'){
            this.$router.push({path: "/dingd/createWxOrderUsa", query: {id:id}})
            return;
          }
        this.$router.push({path: "/dingd/createWxOrder", query: {id: id}})
        return;
      } else {
        //上海直销
        this.$router.push({path: "/dingd/createNxOrder", query: {id: id}})
      }
    },
    //冲销
    updateBillBlkFw(x) {
      var sapCodes = [];
      /*                this.tableSelectedList.forEach((item, index) => {
                          this.kaipiao.id = item.id;
                          this.kaipiao.acceptTime = item.acceptTime;
                          sapCodes.push(this.kaipiao)
                      })*/
      this.kaipiao.id = x.id;
      this.kaipiao.acceptTime = x.acceptTime;
      this.kaipiao.sapCodes = x.sapCodes;
      sapCodes.push(this.kaipiao)
      this.$msg.confirm("确认签收?", () => {
        ss.OrderMainService.updateBillBlk(sapCodes).then(rd => {
          this.$msg.msgs(rd.msg);
          this.query();
        });
      });
    },
    handleDelete(row) {

    },
    //导出Excel
    /*downloadExcel() {

        var idlist = [];
        this.multipleSelection.forEach(element => {
            idlist.push(element.pid);
        });

        this.q.ids = idlist;
        this.q.orderCategory = this.formInline.orderCategory;
        this.q.orderType = this.formInline.orderType;
        this.q.cucode = this.formInline.cucode;
        this.q.cunameLike = this.formInline.cunameLike;
        this.q.saleGroupCode = this.formInline.saleGroupCode;
        this.q.orderStatus = this.formInline.orderStatus;

        updownfile.down("/api/swyl/v1/bsc/order/getOrderExcel?ids=" + this.q.ids, this.q.ids, "get", "data");

    },*/
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property]
      if(data == null) {
        return null
      }
      let dt = new Date(data)
      return this.$util.riQi3(dt);
    },
      //报关草单打印
      printDraftDeclaration(){

          if(this.tableSelectedList.length == 0){
              this.$msg.msge("至少选中一条操作！");
              return false;
          }

          var flag = false;
          var flag1 = false;
          var flag2 = false;
          var flag3 = false;
          var soldTocode = this.tableSelectedList[0].soldToCode;
          var saleGroupCode = this.tableSelectedList[0].saleGroupCode;
          var factory = this.tableSelectedList[0].factory;
          //遍历数据
          this.tableSelectedList.forEach((item, index) => {
              if(item.soldToCode != soldTocode){
                  flag = true;
                  return;
              }
              if(item.saleGroupCode != saleGroupCode){
                  flag2 = true;
                  return;
              }
              if(item.factory != factory){
                  flag3 = true;
                  return;
              }
          })
          if(flag){
              this.$msg.msge("必须选择同一经销商的订单！");
              return;
          }
          if(flag2){
              this.$msg.msge("销售组织不一致，请重新选择！");
              return;
          }
          // if(flag3){
          //     this.$msg.msge("产地不一致，请重新选择！");
          //     return;
          // }

          ss.declaration.getDeclaration(this.tableSelectedList).then(rd => {
              if(rd.f) {
                  var data = rd.msg;
                  for(var i=0;i<data.length;i++){
                      updownfile.down('/api/swyl/v1/dingd/declaration/draft/downloadExcel',data[i],"post",'data');
                  }
              }
          })

      },
      //申报要素打印
      printElements(){

          if(this.tableSelectedList.length == 0){
              this.$msg.msge("至少选中一条操作！");
              return false;
          }

          var flag = false;
          var flag1 = false;
          var flag2 = false;
          var flag3 = false;
          var soldTocode = this.tableSelectedList[0].soldToCode;
          var saleGroupCode = this.tableSelectedList[0].saleGroupCode;
          var factory = this.tableSelectedList[0].factory;
          var idList = [];
          //遍历数据
          this.tableSelectedList.forEach((item, index) => {
              if(item.soldToCode != soldTocode){
                  flag = true;
                  return;
              }
              if(item.saleGroupCode != saleGroupCode){
                  flag2 = true;
                  return;
              }
           /*   if(item.factory != factory){
                  flag3 = true;
                  return;
              }*/

          })
          if(flag){
              this.$msg.msge("必须选择同一经销商的订单！");
              return;
          }
          if(flag1){
              this.$msg.msge("选择的订单状态必须为等待下发计划及之后状态的订单！");
              return;
          }
          if(flag2){
              this.$msg.msge("销售组织不一致，请重新选择！");
              return;
          }
          for(var i = 0;i<this.tableSelectedList.length;i++){
              idList.push(this.tableSelectedList[i].bid)
          }
          // if(flag3){
          //     this.$msg.msge("产地不一致，请重新选择！");
          //     return;
          // }

          ss.declaration.checkDeclaration(idList).then(rd => {
              if(rd.f){
                  var data = rd.msg;
                  for(var i=0;i<data.length;i++) {
                      let ids = data[i];
                      updownfile.down("/api/swyl/v1/dingd/declaration/oversea/downloadElementsExcel", {ids:ids}, "post");
                  }
              }
          })

      },
  },

  mounted() {
    this.getdatatime()
  },


}
</script>
<style scoped>
.xiangmu .h-piece, .h-mrt30 {
  margin: 20px;
}

.h-formBtnOut .h-mr20 {
  margin-left: 1rem !important;
}

.D-date .el-cascader {
  line-height: 0;
}

</style>
